module.exports = __webpack_public_path__ + "img/P19-en.5d4c6a9e.png";